var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333V17.5M10 17.5H15M10 17.5H5M6.66667 10.8333L6.66667 9.16667M10 10.8333L10 5.83333M13.3333 10.8333V7.5M5.16667 13.3333H14.8333C15.7668 13.3333 16.2335 13.3333 16.59 13.1517C16.9036 12.9919 17.1586 12.7369 17.3183 12.4233C17.5 12.0668 17.5 11.6001 17.5 10.6667V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84144 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5H5.16667C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667V10.6667C2.5 11.6001 2.5 12.0668 2.68166 12.4233C2.84144 12.7369 3.09641 12.9919 3.41002 13.1517C3.76654 13.3333 4.23325 13.3333 5.16667 13.3333Z",
    stroke: "#026735",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageStatistics);
export default __webpack_public_path__ + "static/media/usageStatistics.3928b877b1e327c93dbcba5dba05f15d.svg";
export { ForwardRef as ReactComponent };